import { Vue } from 'vue-property-decorator'

export function nestedEmitter(parent: Vue, emitName: string, args: any = null) {
  let vm = parent
  while (vm) {
    vm.$emit(emitName, args)
    vm = vm.$parent
  }
}
